import React from "react";
import { Link } from "react-router-dom";
import { Dumbbell } from "lucide-react";

const LegalFooter = () => {
  return (
    <footer className="py-12 px-6 border-t border-white/5 bg-[#030711]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Dumbbell className="w-6 h-6 text-blue-500" />
              <span className="font-bold tracking-tight">PALADIN</span>
            </div>
            <p className="text-gray-500 text-sm">
              Health & Human Performance
            </p>
            <p className="text-gray-600 text-xs mt-2">
              High-performance training for serious athletes.
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/cancellation" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Cancellation & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/waiver" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Health & Liability Waiver
                </Link>
              </li>
            </ul>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/philosophy" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Our Philosophy
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Sign In
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a href="mailto:support@paladinhhp.com" className="text-gray-400 hover:text-white text-sm transition-colors">
                  support@paladinhhp.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Paladin Health & Human Performance. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">
            HEALTH FIRST | PERFORMANCE ALWAYS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
